import React from 'react';
import '../components/TeamMembers.css'; // Make sure this path is correct
import teamHeaderImg from "../assets/imgs/team-header-image.png"
import TeamMembers from "../components/TeamMembers";

const TeamSection = () => {
    return (
        <>
            <section className="team-header-section">
                <div className="container">
                    <div className="row">
                        <div className="team-header-text col-sm-12 col-lg-6 col-md-12 col-xl-6">
                            <h1 className="team-header-h1"> MEET OUR BEST TEAM</h1>
                            <p className="team-header-p">Cras eu dignissim mauris. Duis imperdiet erat sapien, molestie aliquet arcu tincidunt id. Mauris sit amet quam mi. Duis porttitor lectus quis turpis malesuada, eu luctus elit dignissim.</p>
                            <div className=" hr-div">
                                <hr/>
                            </div>
                        </div>
                        <div className="team-header-img col-sm-12 col-lg-6 col-md-12 col-xl-6">
                            <div className="d-flex align-items-center justify-content-center">
                                <img src={teamHeaderImg} alt="hearder team" className="team-header-image"/>
                            </div>
                            <p class="d-flex justify-content-center align-items-center mt-4"><b>Steffi Allysa</b></p>
                            <p class="d-flex justify-content-center align-items-center mb-4">Chief Creative Officer</p>

                        </div>
                    </div>
                </div>

            </section>

            <TeamMembers/>


        </>
    );
};

export default TeamSection;
